import { trackMetaStoreClick } from "./meta";

export function trackCTA(action: string, label: string) {
  if (typeof window.gtag === "function") {
    window.gtag("event", action, {
      event_category: "CTA",
      event_label: label,
    });
  }
}

const ADS_ID = import.meta.env.VITE_GOOGLE_ADS_ID;

export function trackConversion(conversionLabel: string) {
  if (typeof window.gtag === "function" && ADS_ID) {
    window.gtag("event", "conversion", { send_to: `${ADS_ID}/${conversionLabel}` });
  }
}

export function trackAppDownload(platform: 'ios' | 'android', location: string) {
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'app_download_click', {
      event_category: 'Download',
      event_label: `${platform} - ${location}`,
      platform: platform,
    });
  }

  trackMetaStoreClick(platform, location);
}
